import { BaseComponent } from "./core/basecomponent";

import * as moment from 'moment-mini';
import { ValidatedInput } from "./validatedinput";

export class TextInputCheckFunctions {
	public static password:TextInputCheckFn = (value:string) => {
		if(value.length<6) {
			return {
				valid: false,
				message: "Minst 6 tecken"
			}
		}
		return {
			valid: true,
			message: ""
		}
	}
	public static email:TextInputCheckFn = (value:string) => {
		if(value.indexOf(".con")==value.length-4) {
			return {
				valid: false,
				message: "Invalid top-domain .con"
			}
		}
		if(value.indexOf("@")!=-1&&value.indexOf(".")!=-1) {
			return {
				valid: true,
				message: ""
			}
		}
		return {
			valid: false,
			message: "Invalid e-mail"
		}
	}
}

export type TextInputCheckFnResult = {
	valid:boolean;
	message:string;
}
export type TextInputCheckFn = (value:string) => TextInputCheckFnResult;

export type TextInputProps = {
	password?: boolean;
	numeric?:boolean;
	decimal?:boolean;
	date?:boolean;
	dateMax?:Date|null;
	dateMin?:Date|null;
	dateMode?:"date"|"time"|"datetime";
	allowFutureDates?:boolean;
	allowPastDates?:boolean;
	initialDate?:Date|null;
	initialValue?:string|null;
	lowercase?:Boolean;
	onInputFocus?:Function|null;
	disabled?:boolean;
	autocapitalize?:boolean;
	autocomplete?:boolean;
	autocorrect?:boolean;
	spellcheck?:boolean;
	allowEmpty?:boolean;
	multiline?:boolean;
	validateEveryChar?:boolean;
	bottomBorder?:boolean;
	checkInput?:TextInputCheckFn|null;
};

const defaultProps:TextInputProps = {
	password: false,
	numeric: false,
	decimal: false,
	date: false,
	dateMax: null,
	dateMin: null,
	dateMode: "date",
	allowFutureDates: true,
	allowPastDates: true,
	initialValue: null,
	initialDate: null,
	lowercase: false,
	onInputFocus: null,
	disabled: false,
	autocapitalize: false,
	autocomplete: false,
	autocorrect: false,
	spellcheck: false,
	allowEmpty: false,
	multiline: false,
	validateEveryChar: false,
	checkInput: null,
	bottomBorder: true
}

export class TextInput extends BaseComponent implements ValidatedInput {

	public static dateInputFormat = "YYYY-MM-DD";
	public static timeInputFormat = "HH:mm"

	label:string = "";
	props: TextInputProps;

	value:string = "";
	dateValue:Date = null;

	valid:boolean = false;


	constructor(parent:JQuery<HTMLElement>, label:string, props:TextInputProps = {}) {
		super(parent, false);
		this.elm.addClass("text-input");

		this.label = label;
		this.props = props;

		//populate defaults where required:
		for(let m in defaultProps) {
			if((props as any)[m]==null) (props as any)[m]=(defaultProps as any)[m];
		}
		if(props.checkInput==null) {
			if(props.date) {
				props.checkInput = (dateStr:string) => {
					return {
						valid: !(dateStr==""),
						message: ""
					}
				}
			} else {
				props.checkInput = (_str:string) => {
					return {
						valid: true,
						message: ""
					}
				}
			}
		}

		let inputFieldHtml:string = `<input type="text" placeholder="" autocapitalize="${(props.autocapitalize?"on":"none")}" autocomplete="${(props.autocomplete?"on":"off")}" autocorrect="${(props.autocorrect?"on":"off")}" spellcheck="${(props.spellcheck?"on":"off")}"></input>`;
		if(props.multiline) {
			this.elm.addClass("multiline");
			inputFieldHtml = `<div class='multiline-input' contenteditable="true" placeholder="" autocapitalize="${(props.autocapitalize?"on":"none")}" autocomplete="${(props.autocomplete?"on":"off")}" autocorrect="${(props.autocorrect?"on":"off")}" spellcheck="${(props.spellcheck?"on":"off")}"></div>`;
		}
		let skipBorderBottomStr:string = "";
		if(props.bottomBorder===false) skipBorderBottomStr = " skip-border-bottom";
		$(`
			<div class="input-wrapper${skipBorderBottomStr}">
				<div class="scroll-elm"></div>
				<div class="input">
					<form id="a"> 
						${inputFieldHtml}
					</form>
				</div>
				<label class="floating-label">
					${this.label}
				</label>
				<label class="error-status-text"></label>
			</div>
		`).appendTo(this.elm); //onkeydown="return event.key != 'Enter';"

		let inputField = (this.props.multiline)?this.elm.find(".multiline-input"):this.elm.find("input");

		if(!this.props.multiline&&this.props.numeric) {
			inputField.attr("pattern", "[0-9]*");
			if(this.props.decimal) {
				inputField.attr("inputmode", null);
				inputField.attr("type", "text");
				inputField.attr("pattern", "[0-9]*");
				inputField.attr("decimal", "true");
			} else {
				inputField.attr("type", "number");
				inputField.attr("inputmode", "numeric");
				inputField.attr("min", "0");
			}
		}

		if(this.props.lowercase) {
			inputField.css("text-transform", "lowercase");
		}

		if(!this.props.multiline&&this.props.password) {
			inputField.attr("type", "password");
		}

		this.elm.find("form")[0].addEventListener('submit', (e) => {
			e.preventDefault();
			this.dispatch("submit");
		}, false);
		inputField.on("input", (ev:any) => {
			var val:string;
			if(this.props.multiline) {
				val = inputField.html().replace(/<div>/i, "\n").replace(/<\/div>/gi, "\n").replace(/<br>/gi, "\n").replace(/<[^>]*>?/gm, '');
				val = val.trim();
			} else {
				val = inputField.val().toString();
			}
			this.value=val;
			if(this.props.validateEveryChar) {
				this.checkInput(val, false);
			} else {
				this.checkInput(val, true);
			}
			this.dispatch("change");
			if(ev.key=="Enter"&&!this.props.multiline) {
				inputField.trigger("blur");
				this.dispatch("submit");
			}
			if(this.props.multiline) {
				//this.elm.height(inputField[0].scrollHeight);
			}
		});
		inputField.on("focus",
			() => {
				this.elm.addClass("selected");
				this.elm.addClass("has-content");
				this.elm.removeClass("error-input");
				if(this.props.onInputFocus!=null) {
					this.props.onInputFocus();
				}
				this.elm.find(".scroll-elm")[0].scrollIntoView();
				this.dispatch("focus");
			}
		);
		inputField.on("focusout", 
			() => {
				var val:string;
				if(this.props.multiline) {
					val = inputField.html().replace(/<div>/i, "\n").replace(/<\/div>/gi, "\n").replace(/<br>/gi, "\n").replace(/<[^>]*>?/gm, '');
					val = val.trim();
				} else {
					val = inputField.val().toString();
				}
				if(this.props.date&&!this.props.multiline) { //browser only
					var date:any;
					if(this.props.dateMode=="time") {
						date = moment(val, TextInput.timeInputFormat).toDate();
					} else {
						date = moment(val, TextInput.dateInputFormat).toDate();
					}
					if(!(date instanceof Date)) {
						this.value="";
						inputField.val(this.value);
						return;
					}
					if(this.props.dateMax!=null&&date.getTime()>this.props.dateMax.getTime()) date = new Date(this.props.dateMax.getTime());
					if(this.props.dateMin!=null&&date.getTime()<this.props.dateMin.getTime()) date = new Date(this.props.dateMin.getTime());
					if(date instanceof Date) {
						if(this.props.dateMode=="time") {
							this.value = moment(date).format(TextInput.timeInputFormat);
						} else {
							this.value = moment(date).format(TextInput.dateInputFormat);
						}
					} else {
						this.value="";
					}
					inputField.val(this.value);
				} else if(this.props.numeric&&!this.props.multiline) {
					var val:string = inputField.val().toString();
					var num = parseInt(val);
					if(this.props.decimal) {
						val = val.replace(/,/gi, ".");
						num = parseFloat(val);
						if(!isNaN(num)) {
							var fixNum = num.toFixed(1);
							num = parseFloat(fixNum);
						}
						if(num!=null&&!isNaN(num)) {
							inputField.val(num);
						}
					}
					if(num==null||isNaN(num)) {
						this.value="";
						inputField.val(this.value);
						return;
					}
					this.value = val;
				} else {
					this.value = val;
					if(this.props.lowercase) this.value = val.toLowerCase();
				}
				this.elm.removeClass("selected");
				if(val=="") {
					this.elm.removeClass("has-content");
				}
				this.checkInput();
				this.dispatch("change");
				this.dispatch("defocus");
			}
		);

		if(this.props.date) {
			if(this.props.initialDate==null) this.props.initialDate = new Date();
			this.setDate(this.props.initialDate);
			this.checkInput();
			this.dispatch("change");
		} else {
			this.setValue(this.props.initialValue||"");
		}

		this.checkInput(this.value, true);
	}
	checkInput(value:string|null = null, discrete:boolean=false) {
		value = value||this.value;

		var inputCheckResult:TextInputCheckFnResult = this.props.checkInput(value);
		if(value==""&&!this.props.allowEmpty) {
			this.valid = false;
			if(!discrete) {
				this.elm.addClass("error-input");
				this.setError("Cannot be empty");
			} else {
				this.elm.removeClass("error-input");
				if(!discrete) this.setError("");
			}
		} else if(inputCheckResult.valid===true) {
			this.valid = true;
			if(!discrete) this.elm.removeClass("error-input");
		} else {
			this.valid = false;
			if(inputCheckResult.message!=null&&inputCheckResult.message.length>0) {
				if(!discrete) this.setError(inputCheckResult.message);
			} else {
				if(!discrete) this.setError("");
			}
			if(!discrete) this.elm.addClass("error-input");
		}
	}
	setError(message:string) {
		if(message==null) {
			this.elm.find(".error-status-text").html("");
		} else {
			this.elm.find(".error-status-text").html(message);
		}
		this.elm.addClass("error-input");
	}
	toggleDatePicker() {
		this.elm.addClass("selected");
		this.elm.addClass("hasContent");
		this.elm.removeClass("errorinput");

		/*App.screenmanager.lock();

		var startDate = this.getDate();
		var options:DatePickerOptions = {
			date: startDate||new Date(),
			mode: this.props.dateMode,
			minDate: null,
			maxDate: null,
			success: (date) => {
				console.log("Got raw date : ", date);

				App.screenmanager.unlock();

				if(this.props.dateMax!=null&&date!=null&&date.getTime()>this.props.dateMax.getTime()) date = new Date(this.props.dateMax.getTime());
				if(this.props.dateMin!=null&&date!=null&&date.getTime()<this.props.dateMin.getTime()) date = new Date(this.props.dateMin.getTime());

				this.dateValue = date;

				console.log("Got date from show : ", this.dateValue);

				if(date==null) {
					if(this.elm.find("input").val()=="") {
						this.elm.addClass("errorinput");
					}
					this.dispatch("change");
					return;
				}
				this.elm.removeClass("selected");

				if(this.props.dateMode=="time") {
					this.value = moment(date).format(TextInput.timeInputFormat);
				} else {
					this.value = moment(date).format(TextInput.dateInputFormat);
				}
				this.elm.find("input").val(this.value.toString());

				this.checkInput();

				this.dispatch("change");
			},
			error: (e) => {
				App.screenmanager.unlock();
				console.error("DatePicker returned error: ", e);
			},
			cancel: () => {
				App.screenmanager.unlock();
				console.error("DatePicker cancelled");
			}
		};

		if(this.props.dateMin!=null) {
			options.minDate = new Date(this.props.dateMin.getTime());
			if(device.platform!=null&&device.platform.toLowerCase().indexOf("android")!=-1) {
				options.minDate = options.minDate.getTime();
			}
		}
		if(this.props.dateMax!=null) {
			options.maxDate = new Date(this.props.dateMax.getTime());
			if(device.platform!=null&&device.platform.toLowerCase().indexOf("android")!=-1) {
				options.maxDate = options.maxDate.getTime();
			}
		}

		if(this.props.dateMode=="time") {
			options.mode = "time";
			options.locale = "en_GB";
			options.android = {is24HourView: true};
		}

		this.datePicker.show(options);*/
	}
	setValue(value:string) {
		this.value = value;
		if(this.props.multiline) {
			this.elm.find(".multiline-input").html(this.value);
		} else {
			this.elm.find("input").val(this.value);
		}
		if(this.value!="") {
			this.elm.addClass("has-content");
		}
		this.checkInput();
	}
	getDate() {
		if(this.value==null||this.value=="") return null;
		if(this.props.dateMode=="time") {
			return moment(moment(new Date()).format(TextInput.dateInputFormat) +" "+ this.value).toDate();
		}
		var d:Date = moment(this.value).toDate();
		if(d instanceof Date) return d;
		return null;
	}
	setDate(d:Date) {
		this.dateValue=d;
		if(this.props.dateMode=="time") {
			this.dateValue = d;
			this.setValue(moment(d).format(TextInput.timeInputFormat));
		} else {
			this.setValue(moment(d).format(TextInput.dateInputFormat));
		}
	}
	getInteger() {
		return parseInt(this.value);
	}
	setInteger(num:number) {
		this.setValue(num.toString());
	}
	getFloat() {
		return parseFloat(this.value);
	}
	setFloat(num:number) {
		this.setValue(num.toString());
	}
	disable() {
		let inputField = (this.props.multiline)?this.elm.find(".multiline-input"):this.elm.find("input");
		inputField.attr("enabled", "false");
		inputField.attr("disabled", "true");
		this.elm.addClass("disabled");
		inputField.css("pointer-events", "none");
	}
	enable() {
		let inputField = (this.props.multiline)?this.elm.find(".multiline-input"):this.elm.find("input");
		inputField.attr("enabled", "true");
		inputField.attr("disabled", "false");
		this.elm.removeClass("disabled");
		inputField.css("pointer-events", "auto");
	}
	select() {
		let inputField = (this.props.multiline)?this.elm.find(".multiline-input"):this.elm.find("input");
		inputField.trigger("focus");
	}
	setLabel(label:string) {
		this.label = label;
		this.elm.find(".floating-label").html(this.label);
	}
}
